<template>
    <fragment>
        <td>{{pickup.activity_group.name}} </td>
        <td>
            <b-form-checkbox
              switch
              size="lg"
              v-model="form.service"
              :id="idx + '-check'"
              :checked="form.service"
              @change="serviceOnChange()"
              :disabled="false"
            ></b-form-checkbox>
        </td>
        <td>
            <v-select
                :options="geopointsListAdmin.filter(entry => entry.is_pickup).filter(entry => entry.sub_zone.pickup_zone.supra_zone.id == suprazone.id).sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1: -1)"
                :reduce="(option) => option.id"
                label="name"
                v-model="form.pickup_point"
                :disabled="!form.service"
                style="width: 17vw"
                class="border"
            >
            </v-select>
        </td>
        <td>
            <b-button
                v-if="form.pickup_point != null && form.pickup_point != 0"
                class="border mr-2"
                size="sm"
                variant="light"
                @click="save"
            >
                <i class="text-center fa fa-save fa-fw"></i>
                Guardar
            </b-button>
            <span v-else-if="!form.service">
                Active servicio para seleccionar parada
            </span>
            <span v-else-if="form.pickup_point == null">
                Seleccione parada del listado
            </span>
            <span v-else>
                Seleccione parada del listado
            </span>
        </td>
    </fragment>
</template>

<script>
/* eslint-disable */
import { Fragment } from 'vue-fragment'

import { mapGetters } from 'vuex';

export default {
    components: {
        Fragment
    },
    props: {
        hotel: {
            type: Object,
            required: true
        },
        pickup: {
            type: Object,
            required: true
        },
        idx: {
            type: Number,
            required: true
        },
        suprazone: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: {
                pickup_point: this.pickup.pickup != null  ? this.pickup.pickup : 0,
                service: this.pickup != null && this.pickup.service != null ? this.pickup.service : true
            },
            service_or_not: [
                {
                    label: 'Sí',
                    value: true,
                },
                {
                    label: 'No',
                    value: false,
                }
            ],
        }
    },
    methods: {
        async save() {
            console.log("test whether it can be saved")
            console.log(this.form)
            if ( this.form.service && this.form.pickup_point == null ) {
                console.log('prevented 2')
                return
            }
            else {
                console.log('save relation')
                const payload = {
                    hotel: this.hotel.id,
                    pickup_point: !this.form.service ? null : this.form.pickup_point instanceof Object ? this.form.pickup_point.id : this.form.pickup_point,
                    activity_group: this.pickup.activity_group.id,
                    service: this.form.service
                }
                await this.$store.dispatch('hotelStopGroups/saveHotelStopGroupRelation', payload)
                this.$notify({
                    group: "foo",
                    title: "Relación guardada",
                    text: "La relación hotel, parada y grupo de actividad se ha guardado satisfactoriamente",
                    type: "success",
                });
            }
        },
        serviceOnChange() {
            if (this.form.service == false)
                this.form.pickup_point = null
        }
    },
    computed: {
        ...mapGetters(['geopointsListAdmin']),
        geopointsBySubzone() {
            let filtered = this.geopointsListAdmin.filter(
                item => item.sub_zone.id == this.hotel.sub_zone.id
            )
            return filtered
        }
    },
    watch: {
        form: {
            handler: function() {
                console.log('form changed')
                // prevent auto saven on condition
                console.log('this.form watch ', this.form)
                if ( this.form.service && this.form.pickup_point == null ) {
                    console.log('prevented')
                    return
                } else
                    this.save()
            },
            deep:true
        },
    }
}
</script>
